export const GROUP_OPTIONS = {
  campaign_id: 'campaign',
  funnel_id: 'funnel',
  c1: 'c1',
  c2: 'c2',
  c3: 'c3'
};
